<template>
  <div>
    <div class="marginLR center">
      <h2 class="titles">Pago cancelado</h2>
      <p class="subtitles">Muchas gracias por tu confianza.</p>
    </div>

    <div class="whitePanel">
      <div class="p-grid">
        <div class="p-col-12 center">
          <router-link to="/">
            <Button
              label="Empezar"
              class="bigBlueButton"
              icon="pi pi-caret-left"
              iconPos="left"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "altaImpagoCancelada",
  data() {
    return {};
  },
  methods: {
    addToStore() {
      this.$store.dispatch("addDatosCliente", this.datosCliente);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>